'use client';

import { type FC, useState } from 'react';
import type { Team } from '@cs-shot/battle-sim';
import { FaShieldAlt, FaStar } from '../icons';
import { bustCache } from './render/battleAssetVersion';

// react-icon fallback used until a side's emblem webp exists (e.g. ct.webp).
const FALLBACK: Record<Team, typeof FaShieldAlt> = { t: FaStar, ct: FaShieldAlt };

/**
 * The CS faction emblem for a side, served from `/battle/${side}.webp`. Falls
 * back to a react icon if that image is missing/failed, so a not-yet-added
 * emblem never shows a broken image.
 */
export const SideIcon: FC<{ side: Team; size?: number; className?: string }> = ({ side, size = 30, className }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    const Icon = FALLBACK[side];
    return <Icon size={size} className={className} />;
  }
  return (
    <img
      src={bustCache(`/battle/${side}.webp`)}
      alt={side}
      className={className}
      style={{ width: size, height: size, objectFit: 'contain' }}
      onError={() => setFailed(true)}
    />
  );
};
